import { ApplicationList } from '../Components/ApplicationList'
import { applicationOwnerOf, canReadApplications } from './ClientApplicationsTab'

import type { ApplicationOwnerRecord } from './ClientApplicationsTab'

export interface CarrierApplicationsTabProps {
    record: ApplicationOwnerRecord | undefined
}

/**
 * Публічне API контейнера заявок для картки перевізника (`SPEC-021` §8.9,
 * `SPEC-025` §3.5): вміст вкладки «Заявки» — префільтр перевізника.
 *
 * «Додати заявку» є (К25.9 звірено з легасі): `CarrierFormTemplate.jsx:160-176`
 * передавав `form.initialValues.carrier` і створення не вимикав — тож нова
 * заявка відкривається з підставленим перевізником. Розміщує вкладку Н-025.4.
 */
export const CarrierApplicationsTab = ({ record }: CarrierApplicationsTabProps) => {
    const owner = applicationOwnerOf(record)

    if (owner === null || !canReadApplications()) return null

    return <ApplicationList ownerField="carrier" owner={owner} />
}
